import {
  Button,
  InputPassword,
  InputWrapper,
  passwordRegex,
} from '@vrplatform/components';
import { Box, PinInput, Stack, Text } from '@mantine/core';
import { Controller, useForm } from 'react-hook-form';

type FormInput = {
  code: string;
  password: string;
  confirmPassword: string;
};

export const ResetPasswordView = ({
  handlePasswordReset,
}: {
  handlePasswordReset: (values: FormInput) => Promise<void>;
}) => {
  const {
    formState: { isSubmitting },
    handleSubmit,
    control,
  } = useForm<FormInput>();

  return (
    <Box maw={'450px'} flex={1}>
      <Text component="p" mt="7vh" mb="3rem" ta="center">
        Please check your email for your 2FA code. If you didn't receive the
        email, we will gladly send you another.
      </Text>
      <Stack
        sx={{
          marginBottom: '3rem',
        }}
      >
        <Controller
          name="code"
          defaultValue=""
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Please enter your 2FA code.',
            },
          }}
          render={({
            field: { value, onChange, name },
            fieldState: { error },
          }) => (
            <InputWrapper
              // htmlFor={name}
              label={'Code'}
              error={error?.message}
              sx={{
                marginBottom: '1.5rem',
                marginInline: 'auto',
              }}
            >
              <PinInput
                data-testid="password-reset-pin-input"
                value={value}
                onChange={onChange}
                name={name}
                length={6}
                size="lg"
              />
            </InputWrapper>
          )}
        />
        <Controller
          name="password"
          defaultValue=""
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Please enter a password.',
            },
            pattern: {
              value: passwordRegex,
              message:
                'Please enter a lower/uppercase letter, one number, one special symbol and at least 8 characters.',
            },
          }}
          render={({
            field: { value, onChange, name },
            fieldState: { error },
          }) => (
            <InputWrapper
              // htmlFor={name}
              label={'Password'}
              error={error?.message}
            >
              <InputPassword
                value={value ?? ''}
                onChange={onChange}
                name={name}
                placeholder="Password"
                error={error?.message}
                autoComplete="new-password"
              />
            </InputWrapper>
          )}
        />
        <Controller
          name="confirmPassword"
          defaultValue=""
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Please confirm your password.',
            },
            pattern: {
              value: passwordRegex,
              message:
                'Please enter a lower/uppercase letter, one number, one special symbol and at least 8 characters.',
            },
          }}
          render={({
            field: { value, onChange, name },
            fieldState: { error },
          }) => (
            <InputWrapper
              // htmlFor={name}
              label="Confirm password"
              error={error?.message}
            >
              <InputPassword
                value={value ?? ''}
                required
                onChange={onChange}
                name={name}
                withPopover={false}
                error={error?.message}
                placeholder="Confirm password"
              />
            </InputWrapper>
          )}
        />
      </Stack>

      <Button
        variant="primary"
        loading={isSubmitting}
        onClick={handleSubmit(handlePasswordReset)}
        sx={(theme) => ({
          marginBottom: theme.spacing.md,
          width: '100%',
        })}
      >
        Reset password
      </Button>
    </Box>
  );
};
